// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__splDo","option":"styles_option__1PHvy","selected":"styles_selected__oXXjd"};